import * as types from '../config/actionTypes';

const CollateralActions = {
	setCollateral: (data) => ({ type: types.SET_COLLATERAL, data }),
	updateCollateral: (data) => ({ type: types.UPDATE_COLLATERAL, data }),
	addCollateral: (data) => ({ type: types.ADD_COLLATERAL, data }),
	backCollateral: (data) => ({ type: types.BACK_COLLATERAL, data })
};

export default CollateralActions;
